import apiClient from './api.service';

const CourseService = {
  // Get all courses
  getAllCourses() {
    return apiClient.get('/course/all');
  },

  // Get course by ID
  getCourseById(id) {
    return apiClient.get(`/course/${id}`);
  },

  // Get courses by teacher
  getCoursesByTeacher(userId) {
    return apiClient.get(`/course/byUser/${userId}`);
  },

  // Approve course
  approveCourse(courseId) {
    return apiClient.post(`/course/admin/approve/${courseId}`);
  },

  // Reject course
  rejectCourse(courseId, reason) {
    return apiClient.post(`/course/admin/reject/${courseId}`, { reason });
  },

  // Update course status
  updateCourseStatus(courseId, status) {
    return apiClient.patch(`/course/admin/status/${courseId}`, { status });
  },

  // Delete course
  deleteCourse(courseId) {
    return apiClient.delete(`/course/admin/${courseId}`);
  },

  // Get pending courses (for approval)
  getPendingCourses() {
    return apiClient.get('/course/admin/pending');
  },

  // Get course statistics
  getCourseStats() {
    return apiClient.get('/course/admin/stats');
  },

  // Update any course field (title, description, fee, schedule, config,
  // contents/chapters, etc). Reuses the same upsert endpoint the teacher
  // app's AddCourse screen uses -- when `course_id` is present in the
  // payload it performs a full `UPDATE courses SET ...` with whatever
  // fields are included, leaving everything else (status, is_live,
  // chapter, ...) untouched.
  updateCourse(courseData) {
    return apiClient.post('/course/add/', { course: courseData });
  }
};

export default CourseService;
